import { Currency } from '../../court-pricing/dto/court-pricing-rule.dto';
import { SportType } from '../../court/dto/court.dto';

export enum ProductCategory {
  EQUIPMENT = 'Equipment',
  BEVERAGES = 'Beverages',
  FOOD = 'Food',
  ACCESSORIES = 'Accessories',
  APPAREL = 'Apparel',
}

export type ProductDto = {
  id: string;
  name: string;
  description?: string;
  sports?: SportType[];
  price: number;
  currency: Currency;
  isActive: boolean;
  stockQuantity: number;
  hasUnlimitedStock: boolean;
  imageUrl?: string;
  category: ProductCategory;
  locationId: string;
  createdAt: Date;
  updatedAt: Date;
};

export class CreateProductDto {
  name: string;

  description?: string;

  sports?: SportType[];

  price: number;

  currency: Currency;

  stockQuantity: number;

  hasUnlimitedStock?: boolean;

  imageUrl?: string;

  category: ProductCategory;

  locationId: string;
}

export class UpdateProductDto {
  name?: string;

  description?: string;

  sports?: SportType[];

  price?: number;

  currency?: Currency;

  stockQuantity?: number;

  hasUnlimitedStock?: boolean;

  imageUrl?: string;

  category?: ProductCategory;

  locationId?: string;

  isActive?: boolean;
}
